export default __webpack_public_path__ + "static/media/Teachersday6.c9fcc2d7.JPG";